"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReplayIcon_1 = require("../../../icons/ReplayIcon");
const IconButton_1 = require("../IconButton");
const ReplayButton_module_css_1 = __importDefault(require("./ReplayButton.module.css"));
/**
 * Replay Button that shows the ReplayIcon
 */
function ReplayButton({ replayStory }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: ReplayButton_module_css_1.default.replayButtonContainer, onClick: replayStory, "data-testid": "replayButtonDiv", children: (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { size: "LARGE", label: "Replay Snap", children: (0, jsx_runtime_1.jsx)(ReplayIcon_1.ReplayIcon, { size: "LARGE" }) }) }));
}
exports.ReplayButton = ReplayButton;
//# sourceMappingURL=ReplayButton.js.map